import {IonAvatar, IonBadge, IonButton, IonCol, IonGrid, IonIcon, IonNote, IonRouterLink, IonRow, IonSelect, IonSelectOption, IonText, useIonAlert, useIonRouter} from "@ionic/react";
import styles_CardDetailFor_7_4 from "./CardDetailFor_7_4.module.scss";
import styles_ContractBonusItem from "./ContractBonusItem.module.scss";
import {bookmark, bookmarkOutline, brushOutline, chatboxEllipses, chatboxEllipsesOutline, heart, heartOutline, star} from "ionicons/icons";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import {ActionLink} from "./ActionLink";
import styles_Common from "../pages/Common.module.scss";
import moment from "moment";
import QRCode from "react-qr-code";
import {useStoreState} from "pullstate";
import {AuthStore, UserEventActivityStore} from "../store/Common_Store";
import {getPageData} from "../store/Selectors";
import useForceRender from "../_/useForceRender";
import styles_Pg_C_1 from "../pages/Pg_C_1.module.scss";
import {constPetCategory} from "../_/constant";
import React, {Fragment, useRef, useState} from "react";
import CustomField from "./CustomField";
import indexBy from "underscore/modules/indexBy";
import {useTokenEnwDetailEditFields} from "./TokenEnwDetailItem";
import {useFormInput, validateForm} from "../_/useForms";
import styles_CardDetailFor_7_2 from "./CardDetailFor_7_2.module.scss";
import {navToPg_1_1, navToPg_7_5, promptBrowserToLogin} from "../pages/Utils";
import {push__pg_7_4_1__buy, push_pg_7_1__savecard, push_pg_7_2_2__competequiz, push_pg_7_3_1_JoinEvent} from "../store/Pg_7_Store";
import styles_7_1 from "../pages/Pg_7_1.module.scss";
import styles_7_2_2 from "../pages/Pg_7_2_2.module.scss";
import styles_Pg_0_3 from "../pages/Pg_0_3.module.scss";
import AriaModal from "./react-aria-modal/src/react-aria-modal";
import styles_7_6 from "../pages/Pg_7_6.module.scss";


export const useAskPhoneFields = (Item_會員積分點數) => {
    return [
        {
            id: "phone",
            label: "法人積分歸納",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "請輸入公司統編",
                    autocomplete: "tel-local"
                },
                state: useFormInput(Item_會員積分點數.法人積分歸納)
            }
        }

    ];
};

// export const useProductEditFields = (Item_Product: any) => {
//     return [
//         {
//             id: "ProductModelId",
//             label: "規格",
//             required: true,
//             input: {
//                 props: {
//                     type: "text",
//                     placeholder: "規格",
//                 },
//                 state: useFormInput(Item_Product.ProductModelId__ListDefault)
//             }
//         },
//     ];
// }

export const CardForPersonStatus = ({
                                        Item_會員積分點數,reload,

                                        fromHome = false,
                                        noLink = false,
                                        onClickCapture = null as any
                                    }) => {
    const router = useIonRouter();
    //const eventJoins = useStoreState(UserEventJoinStore, getPageData);
    const forceRender = useForceRender();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [presentAlert] = useIonAlert();

    // let _Category: any = Item_Product?._Category;
    // if (!_Category) {
    //     return <>(ERROR:_Category)</>;
    // }
    //
    // let _Models: any = Item_Product?._Models;
    // if (!_Models) {
    //     return <>(ERROR:_Models)</>;
    // }
    //
    // let keyedModel = indexBy(Item_Product._Models, 'ProductModelId');

    const [errors, setErrors] = useState(false);

    const fields = useAskPhoneFields(Item_會員積分點數);
    let keyedFields = indexBy(fields, 'id');

    //#region WarnDialog Event
    let [warnDialogActive, setWarnDialogActive] = useState<boolean>(false);
    let refWarnDialogData: any = useRef<string>(null);

    let getApplicationNode = () => {
        return document.getElementById("root");
    };

    let deactivateWarnDialogModal = (e: any = null) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setWarnDialogActive(false);
        refWarnDialogData.current = null;
    };

    let warnDialog = (props: {
        warnType: string,
        done?: any,
    }) => {
        return async (e?: any) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            refWarnDialogData.current = props;
            setWarnDialogActive(true);
            forceRender();
        };
    };

    //#endregion


    const _pushEnterPhone = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        const errors = validateForm(fields);
        setErrors(errors);

        if (!errors.length) {
            const No = fields && (keyedFields.phone as any).input.state.value;

            if (await push_pg_7_1__savecard({
                p1: No,
            })) {
                //navToPg_1_1();
                //await reload();
                deactivateWarnDialogModal();

                presentAlert({
                    backdropDismiss: false,
                    keyboardClose: false,
                    header: '修改成功！',
                    //subHeader: 'A Sub Header Is Optional',
                    //message: Item_Sdgs課程.名稱,
                    buttons: [
                        // {
                        //     text: '稍後再在測驗',
                        //     role: 'cancel',
                        //     handler: () => {
                        //         //reload();
                        //     },
                        // },
                        {
                            text: '了解',
                            role: 'confirm',
                            handler: () => {
                                //navToPg_7_5(router);
                                reload();
                            },
                        },
                    ]
                })
            }
        }



        return true;
    };

    const clickPromptForm = async () => {
        try {
            await warnDialog({
                warnType: "enterCompanyNo",
                // done: async () => {
                //
                //
                //     if (await _pushEnterPhone()) {
                //         deactivateWarnDialogModal();
                //     }
                // }
            })();
        } catch(err) {
            alert(err);
        }
    }


    //#region WarnDialog Model
    let warnDialogModal: any = null;
    if (warnDialogActive) {
        let warnDialogBody: any = null;
        let {warnType, ...moreWarnProps} = refWarnDialogData.current;

        if (warnType === "rightAnswer") {
            warnDialogBody = <Fragment>
                <div className={`warn-aboutDistance`} key={warnType}>
                    <div className={`${styles_7_2_2.popupDialog}`}>
                        <div className="warn_badge">恭喜您通過測驗！</div>
                        <div className="warn_foot">
                            <div className="buttons">
                                <div className="button_2 button" onClick={moreWarnProps.done}>查詢積分紀錄</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>;
        }
        if (warnType === "enterCompanyNo") {
            warnDialogBody = <React.Fragment>
                <div  className={`warn-enterPhone`} key={`warn-enterPhone`}>
                    <div className={`${styles_7_2_2.popupDialog}`}>

                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol>
                                    <h2>修改登記資料</h2>
                                    <div className={`${styles_Pg_0_3.line} ${styles_Pg_0_3.topBottomSpacing}`}></div>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    法人積分歸納:
                                    <CustomField id={`WarnEnterPhoneFocus`} tabindex={0} field={keyedFields.phone} errors={errors} noLabel={true} isHideField={false}/>
                                </IonCol>
                            </IonRow>



                            {/*<div className="warn_badge">*/}
                            {/*    <div className="warn_form">*/}
                            {/*        <CustomField field={keyedFields.phone} errors={errors} />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="warn_foot">
                                <div className="buttons">
                                    <IonButton tabIndex={0} onClick={_pushEnterPhone}>確認</IonButton>
                                    {/*<div className="button_2 button" ></div>*/}
                                </div>
                            </div>
                        </IonGrid>
                    </div>
                </div>
            </React.Fragment>;
        }

        warnDialogModal = warnDialogBody && <Fragment>
            <AriaModal
                //includeDefaultStyles={false}
                titleText="dunno"
                onExit={deactivateWarnDialogModal}
                initialFocusElement="#WarnEnterPhoneFocus"
                getApplicationNode={getApplicationNode}
                underlayStyle={{
                    paddingTop: "44px",
                    textAlign: "center",
                    background: "inherit",
                    //top: '40px',
                    cursor: "default",
                    backgroundColor: "rgba(0,0,0,0.25)",
                    overflowY: "auto"
                }}
                verticallyCenter={true}
                dialogStyle={{
                    //borderRadius: '6px',
                    //boxShadow: '0 0 6px 0 rgb(0 65 143 / 10%)',
                    //backgroundColor: '#fff',
                    //width: "calc(100% - 16px)"
                    width: "414px"
                }}
                //focusDialog={true}
            >
                {warnDialogBody}
            </AriaModal>
        </Fragment>;
    }
    //#endregion

    if (!Item_會員) {
        return <>(ERROR:Item_會員)</>;
    }

    if (!Item_會員積分點數) {
        return <>(ERROR:Item_會員積分點數)</>;
    }

    return (
        <>
            <div className="l card">
                <div className={styles_7_6.limg}>
                    {Ln_TokenPictureSetCoverImg({
                        圖片組: Item_會員.個人照片,
                        名稱: 'cover',
                    })}
                </div>
            </div>
            <div className="r card">
                <article>
                    <div className={styles_7_1.titleText}>{Item_會員.暱稱}</div>
                    <div onClick={() => clickPromptForm()} className={styles_7_1.descText}>環境尖兵/地球助理/永續領袖 法人積分歸納 {Item_會員積分點數.法人積分歸納} <IonIcon icon={brushOutline}/></div>
                    <div className={styles_7_1.twinbtns}>
                        <div className="col">
                            <div className="l">積分</div>
                            <div className="l">{Item_會員積分點數.已累積積分}</div>
                        </div>
                        <div className="col">
                            <div className="l">點數</div>
                            <div className="l">{Item_會員積分點數.可用點數}</div>
                        </div>
                        <div className="col">
                            <div className="l">徽章</div>
                            <div className="l">{Item_會員積分點數.已收集勳章數}</div>
                        </div>
                    </div>
                    <div className={styles_7_1.ttwinbtns}>
                        <ActionLink link={`/tabs/7_5`} noLink={false}>
                            <IonButton className="custom-button" expand="block">查詢積分紀錄</IonButton>
                        </ActionLink>
                        <ActionLink link={`/tabs/7_6`} noLink={false}>
                            <IonButton className="custom-button" expand="block">查詢點數兌換</IonButton>
                        </ActionLink>
                    </div>
                </article>
            </div>
            {warnDialogModal}
        </>
    );
}
